export default "__VITE_PUBLIC_ASSET__9c7e2f59__"